import React from 'react';
import { useState, useRef, useEffect } from "react";
import "./Careers.css";
import CareerImg from '../images/carrers.png'
import { Button } from "react-bootstrap";
import { Link, useNavigate, handleNavigation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { ArrowUpRight } from "react-feather"; // Using react-feather for the arrow icon
import SubscribeIcon from "../images/explore.png"; // Adjust the path to your circular icon image


function Careers() {

    // Prodcuts Series Starts

    const swiper1Ref = useRef(null);
    const swiper2Ref = useRef(null);

    // Function to attach hover events
    const attachHoverEvents = (swiperRef) => {
        if (swiperRef.current && swiperRef.current.el) {
            swiperRef.current.el.addEventListener("mouseenter", () => swiperRef.current.autoplay.stop());
            swiperRef.current.el.addEventListener("mouseleave", () => swiperRef.current.autoplay.start());
        }
    };

    // Attach event listeners when Swiper initializes
    useEffect(() => {
        if (swiper1Ref.current) attachHoverEvents(swiper1Ref);
        if (swiper2Ref.current) attachHoverEvents(swiper2Ref);
    }, []);

    useEffect(() => {
        if (swiper1Ref.current && swiper1Ref.current.swiper) {
            swiper1Ref.current.swiper.params.navigation.prevEl = ".prev1";
            swiper1Ref.current.swiper.params.navigation.nextEl = ".next1";
            swiper1Ref.current.swiper.navigation.init();
            swiper1Ref.current.swiper.navigation.update();
        }

        if (swiper2Ref.current && swiper2Ref.current.swiper) {
            swiper2Ref.current.swiper.params.navigation.prevEl = ".prev2";
            swiper2Ref.current.swiper.params.navigation.nextEl = ".next2";
            swiper2Ref.current.swiper.navigation.init();
            swiper2Ref.current.swiper.navigation.update();
        }
    }, []);

    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Submitting...");

        try {
            const formData = new FormData();
            formData.append("email", email);

            const response = await fetch("https://peracause.com/backend-files/premier-pumps-usa/newsletter-premier-pumps.php", {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                setStatus("✅ Successfully subscribed!");
                setEmail("");
            } else {
                setStatus("❌ Subscription failed. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            setStatus("⚠️ An error occurred. Please try again later.");
        }
    }
    // Writing Items
    const writingItems = [
        {
            id: 1,
            image: require("../images/latest-writing/news-4.png"),
            name: "PV60",
            date: "23 April 2025",
            description: `
      <p>PREMIER 200 compressor system packages for FLUE GAS DESULFURIZATION application. Designed for handling 24,000 CFM of flue gas at 0.6 kg/cm² discharge pressure. Made with S.S 316L material grade to withstand the extreme corrosive operating environment of Sulphuric Acid as a result of Sulphur vapours reacting with water.</p>
    `
        },
        {
            id: 2,
            image: require("../images/latest-writing/news-7.jpeg"),
            name: "PV60",
            date: "09 January 2025",
            description: `
      <p>PREMIER offers its unique performance evaluation services for Liquid Ring Vacuum Pumps with minimum pump shutdown time, giving in time failure predictions and minimizing plant shutdown costs due to pump failure.</p>
    `
        },
        {
            id: 3,
            image: require("../images/latest-writing/news-3.jpg"),
            name: "PV60",
            date: "16 November 2024",
            description: `
      <p>PREMIER make P501 M pump equivalent to NASH 904 M arrives in a paper mill in the U.S.A</p>
      <p>Contact PREMIER for your emergency requirements to replace your existing O.E.M Vacuum Pumps and spares.</p>
    `
        },
        {
            id: 4,
            image: require("../images/latest-writing/news-5.png"),
            name: "PV60",
            date: "14 August 2024",
            description: `
      <p>PREMIER make centrifugal pumps for pulp and process fluid handling applications.</p>
      <p>With several models covering a wide range of flow and head requirements, PREMIER can supply pumps in various material grades to handle corrosive fluid applications.</p>
    `
        },
        {
            id: 5,
            image: require("../images/latest-writing/news-8.jpeg"),
            name: "PV60",
            date: "31 May 2024",
            description: `
      <p>PREMIER, the ASH HANDLING Vacuum system experts, can provide 100% interchangeable pumps and spares of any O.E.M with material grades that are ideal for abrasive ash handling applications.</p>
    `
        },
        {
            id: 6,
            image: require("../images/latest-writing/news-2.jpg"),
            name: "P300",
            date: "07 February 2024",
            description: `
      <p>PREMIER make Vacuum Pump port plates in S.S. 304 to withstand the demanding environment of Ash Handling in Thermal Power Plants.</p>
      <p>PREMIER guarantees 100% interchangeability with your existing O.E.M pumps and spares.</p>
    `
        },
        {
            id: 8,
            image: require("../images/latest-writing/news-6.png"),
            name: "PV60",
            date: "12 October 2024",
            description: `
      <p>How do you create compelling presentations that wow your colleagues and impress your managers?</p>
      <ul>
        <li>Structure your narrative logically</li>
        <li>Highlight key points visually</li>
        <li>Prepare for audience questions</li>
      </ul>
    `
        },
        {
            id: 9,
            image: require("../images/latest-writing/news-9.jpg"),
            name: "PV60",
            date: "29 July 2023",
            description: `
      <p>PREMIER's in house three ton capacity Dynamic Balancing machine. </p>
      <p>All rotor shaft assemblies are dynamically balanced as per ISO 1940 G6.3 </p>
    `
        },
        {
            id: 10,
            image: require("../images/latest-writing/news-10.jpg"),
            name: "PV60",
            date: "11 March 2023",
            description: `
      <p>PREMIER team conducting a product training seminar in B.H.E.L</p>
    `
        },
    ];
    // Writing Items

    return (
        <div>
            <section class="container-fluid about-hero py-4">
                <div class="container py-md-5 py-0">
                    <div class="row justify-content-center align-items-center py-md-5 py-0">
                        <div class="col-lg-3">
                            <h2 class="fs-1 text-blue">Careers</h2>
                        </div>
                        <div class="col-lg-7">
                            <p class="fs-5">At <span className='text-blue'>PREMIER,</span> we are making the world's process industries efficient one step at a time by manufacturing pumps that are innovative in design and responsive to the evolving industry demands. PREMIER is continuously striving to build a better workplace environment where it's people can deliver their best.
                            </p>
                            <p class="fs-5">
                                We are looking for energetic and innovative people who share our passion for engineering. If you share our passion and want to join us in our mission, please submit your resume and details to <a className='text-decoration-none' href='mailto:hr@premierpumps.com'>HR.</a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>


            <section class="container-fluid py-5">
                <div class="container openings-container rounded-3 shadow">
                    <div class="row col-lg-11 ">
                        <div class="col-md-4 d-flex align-items-center flex-column">
                            <div class="card-border bg-blue col-9"></div>
                            <div class="py-md-5 py-2">

                                <h2 className='text-center mt-0'>
                                    Join our team
                                </h2>
                                <div className='p-4'>
                                    <img src={CareerImg} className='img-fluid rounded-15' />
                                </div>
                            </div>

                        </div>
                        <div class="col-md-8 py-md-5 px-3">
                            <div class="opening-card py-4">
                                <h4 class="text-blue">Production Engineer</h4>
                                <p class=" mb-4"><span className='fw-bold'>Qualification </span>: B.E/B.Tech (Mechanical)</p>
                                <a href="mailto:hr@premierpumps.com" class="text-decoration-none fw-bold text-blue">Apply Now <i class="fa-solid fa-arrow-right ms-1"></i></a>
                            </div>

                            <div class="opening-card py-4">
                                <h4 class="text-blue">Design Engineer</h4>
                                <p class=" "><span className='fw-bold'>Qualification </span>: B.E/B.Tech (Mechanical)</p>
                                <p className='mb-4'>Candidates should have proficiency in CAD softwares.</p>

                                <a href="mailto:hr@premierpumps.com" class="text-decoration-none  fw-bold text-blue">Apply Now <i class="fa-solid fa-arrow-right ms-1"></i></a>
                            </div>

                            <div class="opening-card py-4 mb-4">
                                <h4 class="text-blue">Front Office/Admin/Accounts</h4>
                                <p class=" mb-4"><span className='fw-bold'>Qualification </span>: Any Degree</p>

                                <a href="mailto:hr@premierpumps.com" class="text-decoration-none  fw-bold text-blue">Apply Now  <i class="fa-solid fa-arrow-right ms-1"></i></a>
                            </div>

                            <p>If you are interested in the listed job position and meet the required qualifications, please contact us at <a className='text-decoration-none' href='mailto:hr@premierpumps.com'>hr@premierpumps.com</a> </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Latest Writing */}
            <div className="latest-writing-section mb-5">
                <div className="container">
                    <h3 className="fw-bold mb-4">Latest Writing</h3>
                    <Swiper
                        ref={swiper1Ref}
                        onSwiper={(swiper) => (swiper1Ref.current = swiper)}
                        modules={[Autoplay, Navigation]}
                        autoplay={{
                            delay: 2000,
                            disableOnInteraction: false,
                        }}
                        speed={1000}
                        loop={true}
                        slidesPerView={4}
                        spaceBetween={20}
                        navigation={{ nextEl: ".next1", prevEl: ".prev1" }}
                        breakpoints={{
                            320: { slidesPerView: 1 },
                            576: { slidesPerView: 2 },
                            768: { slidesPerView: 2 },
                            992: { slidesPerView: 3 },
                        }}
                        onMouseEnter={() => swiper1Ref.current?.autoplay.stop()}
                        onMouseLeave={() => swiper1Ref.current?.autoplay.start()}
                    >
                        {writingItems.map((item) => {
                            const plainText = item.description.replace(/<\/?[^>]+(>|$)/g, "");
                            const shortText = plainText.length > 80 ? plainText.substring(0, 80) + "..." : plainText;

                            return (
                                <SwiperSlide key={item.id} className="h-100">
                                    <Link
                                        to={`/writing-details/${item.id}`}
                                        state={{
                                            name: item.name,
                                            date: item.date,
                                            description: item.description,
                                            image: item.image
                                        }}
                                        className="text-decoration-none h-100 d-block"
                                    >
                                        <div className="writing-slide-card bg-white shadow-sm h-100">
                                            <div className="d-flex flex-column h-100">
                                                <img
                                                    src={item.image}
                                                    alt={item.name}
                                                    className="card-img-top mx-auto"
                                                />
                                                <div className="card-body mt-auto p-3 fs-sm-12">
                                                    <p className="">{item.date}</p>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <p className="mb-0 text-dark small flex-grow-1 me-3">{shortText}</p>
                                                        <ArrowUpRight size={20} className="text-blue flex-shrink-0" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>

                    {/* Custom Navigation Buttons */}
                    <div className="d-flex justify-content-end mt-4">
                        <button className="btn btn-outline-primary me-2 prev1 px-4 py-0 fs-5">&#8249;</button>
                        <button className="btn btn-outline-primary next1  px-4 py-0 fs-5">&#8250;</button>
                    </div>
                    <div className='text-center d-flex justify-content-center'>
                        <Link to="/news" className="text-decoration-none">
                            <Button
                                variant="outline-primary text-dark rounded"
                                className="d-flex align-items-center py-2 px-4 fs-5 rounded my-md-0 my-2"
                            >
                                View All <ArrowUpRight size={18} className="ms-2" />
                            </Button>
                        </Link>

                    </div>


                </div>
            </div>
            {/* Latest Writing */}

            {/* Explore Starts */}
            {/* // Subscribe Newsletter Section */}
            <div className="subscribe-newsletter-section my-md-5 my-0">
                <div className="container py-3">
                    <div className="subscribe-inner">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-lg-3 col-md-3 col-sm-12 text-center text-md-start mb-3 mb-md-0">
                                <img
                                    src={SubscribeIcon}
                                    alt="Subscribe Icon"
                                    className="subscribe-icon img-fluid floating"
                                />
                            </div>
                            <div className="col-lg-6 col-md-9 col-sm-12">
                                <div className="subscribe-content">
                                    <h3 className="subscribe-heading mb-3 fw-bold text-md-start text-center">
                                        Subscribe Newsletter
                                    </h3>
                                    <form onSubmit={handleSubmit}>
                                        <div className="d-flex align-items-center justify-content-md-start justify-content-center position-relative">
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Enter your email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                                className="form-control subscribe-input me-2 py-4 bg-white border-0 rounded-15"
                                            />
                                            <button
                                                type="submit"
                                                className="btn subscribe-button py-2 fs-5 px-4 position-absolute end-0 me-3"
                                            >
                                                <i className="fa-regular fa-envelope me-md-4 me-2 fs-4"></i>
                                                Subscribe
                                            </button>
                                        </div>
                                    </form>
                                    {status && (
                                        <p className="mt-3 text-md-start text-center" style={{ color: "#004080" }}>
                                            {status}
                                        </p>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Explore Ends */}
        </div>
    )
}

export default Careers